import { z } from 'zod';
import { FinishMaterialSchema, CreateFinishMaterialSchema } from './finish-material.schema';
import {
  FinishCostItemLinkSchema,
  CreateFinishCostItemLinkSchema,
} from './finish-cost-item.schema';

export const FinishSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  finish_type_id: z.string().uuid().nullable(),
  finish_type: z.string().nullable().optional(), // denormalized display name
  color: z.string().nullable(),
  cost_per_sqft: z.number().default(0), // computed from materials
  notes: z.string().nullable(),
  active: z.boolean().default(true),
  materials: z.array(FinishMaterialSchema).default([]),
  cost_items: z.array(FinishCostItemLinkSchema).default([]),
  materials_cost_per_sqft: z.number().default(0),
  cost_items_cost_per_sqft: z.number().default(0),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateFinishSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  finish_type_id: z.string().uuid().nullable().optional(),
  color: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  active: z.boolean().default(true),
  materials: z.array(CreateFinishMaterialSchema).default([]),
  cost_items: z.array(CreateFinishCostItemLinkSchema).default([]),
});

export const UpdateFinishSchema = CreateFinishSchema.partial();

export type Finish = z.infer<typeof FinishSchema>;
export type CreateFinish = z.infer<typeof CreateFinishSchema>;
export type UpdateFinish = z.infer<typeof UpdateFinishSchema>;
